module.exports = "<a class=\"link link-primary\"\r\n    ng-click=\"$ctrl.toggle()\"><b>{{$ctrl.langs[$ctrl.lang]}}</b></a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/guest/components/idioma/template.html
// module id = 3009
// module chunks = 0